import { LineStringGeometry } from 'app/agriculture/queries/types/geometry/LineStringGeometry';
import { PolygonGeometry } from 'app/agriculture/queries/types/geometry/PolygonGeometry';
import { PointGeometry } from 'app/agriculture/queries/types/geometry/PointGeometry';

export function geometryToPositions({
    type,
    coordinates,
}: PointGeometry | LineStringGeometry | PolygonGeometry) {
    switch (type) {
        case 'Point': {
            return Cesium.Cartesian3.fromDegreesArray(coordinates);
        }
        case 'LineString': {
            return Cesium.Cartesian3.fromDegreesArray(coordinates.flat());
        }
        case 'Polygon': {
            const [polygon = []] = coordinates;
            return Cesium.Cartesian3.fromDegreesArray(polygon.flat());
        }
    }
}
